/* eslint-disable no-unused-vars */
import {useEffect, useRef} from "react";
import clsx from "clsx";
import * as Yup from "yup";
import {useHistory} from "react-router-dom";
import {DashboardLayout} from "components/Layout";
import {Formik} from "formik";
import {SubmitButton} from "components/Button";
import {useToast} from "hooks/useToast";
import {convertErrorMessageFormat} from "utils/converter";
import {useEditMedicineCategory, useDetailMedicineCategory} from "hooks/SuperAdmin/MedicineCategory";
import {CircleLoader} from "components/Loader";
import {FormCard} from "components/Form";
import {useParams} from "react-router-dom";

const FormSchemaValidation = Yup.object().shape({
	name: Yup.string().required("Nama kategori obat wajib di isi"),
});
const FormInitialValues = {name: ""};

export function MedicineCategoryEditPage() {
	const {showToast} = useToast();
	const formikRef = useRef();
	const history = useHistory();
	const params = useParams();
	const {id} = params;
	const {isLoading: loadingFetcing, error, isError, data: detailMedicineCategory} = useDetailMedicineCategory(id);
	const {mutate, isLoading: isSubmitting} = useEditMedicineCategory();
	const handleSubmit = formData => {
		mutate(
			{id, ...formData},
			{
				onSuccess: () => {
					showToast("success", "Data berhasil diperbarui");
					history.push("/kategori-obat");
				},
				onError: res => {
					showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
				},
			},
		);
	};

	useEffect(() => {
		if (detailMedicineCategory) formikRef.current.setFieldValue("name", detailMedicineCategory?.data?.name);
	}, [detailMedicineCategory]);

	if (loadingFetcing) {
		return (
			<DashboardLayout>
				<FormCard title="Edit Kategori Obat">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<Formik
				initialValues={FormInitialValues}
				innerRef={formikRef}
				validationSchema={FormSchemaValidation}
				onSubmit={handleSubmit}>
				{({handleSubmit, handleBlur, handleChange, values, errors}) => (
					<FormCard
						backTitle="Daftar List Kategori Obat"
						title="Edit Kategori Obat"
						onBackButtonClick={() => history.push("/kategori-obat")}>
						<div class="row gx-2 mb-5">
							<div class="col-sm-6 col-6">
								<div class="setting-item">
									<label class="setting-label required">Nama Kategori Obat</label>
									<input
										class={clsx("form-control", errors?.name && "form-control-error")}
										disabled={isSubmitting}
										name="name"
										placeholder=""
										type="text"
										value={values?.name}
										onBlur={handleBlur}
										onChange={handleChange}
									/>
									{errors.name && <p className="form-error-item-message">{errors.name}</p>}
								</div>
							</div>
						</div>

						<div class="text-center my-3">
							<SubmitButton
								className="btn btn-orange d-inline-block mw-250"
								disabled={!FormSchemaValidation.isValidSync(values)}
								loading={isSubmitting}
								text="Simpan Perubahan"
								onClick={handleSubmit}
							/>
						</div>
					</FormCard>
				)}
			</Formik>
		</DashboardLayout>
	);
}
